import { forwardRef } from 'react'
import { TextTypography } from './Text.styles'
import { TextProps } from './Text.types'

const Text = forwardRef<HTMLElement, TextProps>(
  (
    {
      className = '',
      value = '',
      children,
      styles,
      lineHeightAuto = false,
      hidden = false,
      ...props
    },
    ref
  ) => {
    return !hidden ? (
      <TextTypography
        className={`Text ${className}`}
        sx={styles}
        ref={ref}
        lineHeightAuto={lineHeightAuto}
        {...props}>
        {value}
        {children}
      </TextTypography>
    ) : null
  }
)

Text.displayName = 'Text'
export default Text
